var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCacheError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 70
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#FFF",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 44,
    x: 8,
    y: 24,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 52V36a8 8 0 000 16zM26 24h20c0-5.523-4.477-10-10-10s-10 4.477-10 10zM64 52V36a8 8 0 010 16z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44l6 6M28 44l-6 6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44 44l6 6M50 44l-6 6"
  }))), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M36 14V4.238"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 58,
    r: 4
  }))));
}

export default SvgCacheError;